import { Resources, useResource } from "Infrastructure/Translations/Resources";
import { AppRouting } from "Infrastructure/Utils/UrlUtils";
import { EntityLink } from "Shared/EntityLink";
import {
  type InformationSection,
  InformationView,
} from "Shared/InformationView";
import { getFormattedValue, phoneMask } from "Shared/Utils/Format/object";

interface PartnerInformationProps {
  companyNumber: string;
  taxNumber: string;
  email: string;
  phone: string;
  address?: string;
  city?: string;
  postalCode?: string;
  state?: string;
  parentPartnerName?: string | null;
  parentPartnerID?: string | null;
  onEdit?: () => void;
}

export const PartnerInformation = ({
  companyNumber,
  taxNumber,
  email,
  phone,
  address,
  city,
  postalCode,
  state,
  parentPartnerName,
  parentPartnerID,
  onEdit,
}: PartnerInformationProps): React.ReactNode => {
  const { t } = useResource();

  const sections: InformationSection[] = [
    {
      items: [
        {
          label: t(Resources.Partners.PartnerDetail.CompanyNumber),
          value: companyNumber,
        },
        {
          label: t(Resources.Partners.PartnerDetail.TaxNumber),
          value: taxNumber,
        },
        { label: t(Resources.Partners.PartnerDetail.Email), value: email },
        {
          label: t(Resources.Partners.PartnerDetail.Phone),
          value: getFormattedValue(phone, undefined, phoneMask),
        },
        { label: t(Resources.Partners.PartnerDetail.Address), value: address },
        { label: t(Resources.Partners.PartnerDetail.City), value: city },
        {
          label: t(Resources.Partners.PartnerDetail.PostalCode),
          value: postalCode,
        },
        { label: t(Resources.Partners.PartnerDetail.State), value: state },
        ...(parentPartnerName
          ? [
              {
                label: t(Resources.Partners.PartnerDetail.ParentPartner),
                value: parentPartnerID ? (
                  <EntityLink
                    label={parentPartnerName}
                    path={AppRouting.PartnerDetail.path(parentPartnerID)}
                  />
                ) : (
                  parentPartnerName
                ),
              },
            ]
          : []),
      ],
    },
  ];

  return (
    <InformationView
      title={t(Resources.Partners.PartnerDetail.Information)}
      editLabel={t(Resources.Partners.PartnerDetail.EditInformation)}
      onEdit={onEdit}
      sections={sections}
    />
  );
};
